import { render, staticRenderFns } from "./MyPrescribeList.vue?vue&type=template&id=3c1bdb8e"
import script from "./MyPrescribeList.vue?vue&type=script&lang=js"
export * from "./MyPrescribeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports